import React from 'react';
import styled, { css } from 'styled-components';
import isClient from 'helpers/isClient';
import useIsMobile from 'hooks/responsive/useIsMobile';
import { breakpoint, sizes } from 'variables';
import RegimeCarousel from './RegimeCarousel';
import RegimeList from './RegimeList';
import RegimePriceButton from './RegimePriceButton';

/* #region  styles */
const Container = styled.div<{ fullWidth: boolean }>`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;

    ${({ fullWidth }) =>
        !fullWidth &&
        css`
            ${breakpoint.up(sizes.md)} {
                width: 50%;
            }

            ${breakpoint.up(sizes.xl)} {
                width: 58%;
                align-items: center;
            }
        `}
`;

const StyledRegimePriceButton = styled(RegimePriceButton)`
    text-align: center;
`;
/* #endregion */

export default function RegimeEntries({
    children,
    fullWidth = false
}: {
    children?: JSX.Element;
    fullWidth?: boolean;
}) {
    const isMobile = useIsMobile();

    return (
        <Container fullWidth={fullWidth}>
            {isMobile ? <RegimeList>{children}</RegimeList> : <RegimeCarousel>{children}</RegimeCarousel>}
            <StyledRegimePriceButton />
        </Container>
    );
}
